import type { CSSProperties } from "react";

export type SubscriptionTier = "free" | "trial" | "pro";

export interface SubscriptionBadge {
  tier: SubscriptionTier;
  label: string;
  className: string;
  style?: CSSProperties;
}

/**
 * Normalize a subscription value into a display badge.
 * null/empty -> Free, "trial" -> Trial, "pro" -> Pro.
 */
export function getSubscriptionBadge(value?: string | null): SubscriptionBadge {
  const normalized = (value ?? "").toString().trim().toLowerCase();

  switch (normalized) {
    case "pro":
      return {
        tier: "pro",
        label: "Pro",
        className: "badge fw-semibold",
        style: { backgroundColor: "#E55921", color: "#fff" },
      };
    case "trial":
      return {
        tier: "trial",
        label: "Trial",
        className: "badge fw-semibold text-dark",
        style: { backgroundColor: "#FFC107" },
      };
    default:
      return {
        tier: "free",
        label: "Free",
        className: "badge fw-semibold",
        style: { backgroundColor: "#6C757D", color: "#fff" },
      };
  }
}
